import { Navigate } from "react-router-dom";
import { useAuth } from "../shared/utilities/authProvider";

const AdminRoute = ({ children }) => {
  const { token, role, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (role !== "admin") {
    return <Navigate to="/employee" replace />;
  }

  return children;
};

export default AdminRoute;